export class HttpError extends Error {
	name = "HttpError";

	constructor(res) {
		const { status, statusText } = res;

		super(`Request Failed: ${status} - ${statusText ?? ""}`);
		this.code = status;
	}
}

export const isHttpError = (error, status) => {
	return error instanceof HttpError && (status == null || error.code === status);
};
